<template>
  <a-cascader
    ref="cascader"
    :options="list"
    :load-data="loadData"
    @change="onChange"
    size="small"
    v-model="value"
    change-on-select
    :placeholder="placeholder"
  />
</template>

<script>
import { nhfMixins } from '../../untils'

export default {
  props: ['value', 'placeholder', 'category'],
  mixins: [nhfMixins],
  data() {
    return {
      list: [],
      val: null,
    }
  },
  watch: {
    value(val) {
      if (!val) this.val = null
    }
  },
  async mounted() {
    // 获取片区id
    let obj = window.localStorage.getItem('factoryDetail')
    let factoryDetail = obj ? JSON.parse(obj) : {}
    let { deptId } = factoryDetail
    const res = await this.listByParentId({ parentId: 0, category: this.category, deptId })
    this.list = res.data.map(this.mapFilter)
  },

  methods: {
    onChange(val, selected) {
      this.$emit('change', val)
      this.$emit('input', val)
      this.$emit('select', selected)
    },

    mapFilter(i) {
      return {
        ...i,
        label: i.name,
        value: i.id,
        isLeaf: !i.hasChildren
      }
    },

    async loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      const { value: parentId } = targetOption
      // 获取片区id
      let obj = window.localStorage.getItem('factoryDetail')
      let factoryDetail = obj ? JSON.parse(obj) : {}
      let { deptId } = factoryDetail
      const res = await this.listByParentId({ parentId, category: this.category, deptId })
      targetOption.loading = false
      targetOption.children = res.data.map(this.mapFilter)
      this.list = [...this.list]
    },
  }

}
</script>